
		import workerPath from "omt:/home/vincentfretin/workspace/handy-work/src/handpose.js?comlink";
		import {wrap} from "comlink";

		export default wrap(new Worker(new URL(workerPath, import.meta.url), {type: "module"}));
	